import Vue from 'vue'

/** The present-mode session opened from a saved copy while offline; idle with the flag off. */
const initialSession = () => ({
  presentationId: null,
  isOffline: false,
  savedAt: null,
})

export const offlinePresentSession = Vue.observable(initialSession())

export const resetOfflinePresentSession = () => {
  Object.assign(offlinePresentSession, initialSession())
}

let offlineShowsStarted = 0

export const countOfflineShowStart = () => { offlineShowsStarted += 1 }

// Taken when a deck load starts, so a load an offline show overtook does not render the server copy over it.
export const offlineShowStartedSince = () => {
  const startedBefore = offlineShowsStarted
  return () => offlineShowsStarted !== startedBefore
}
